import { createApp } from 'vue';
import QuizApp from './quizAppStorefront.vue';
import { getVuexStore } from './store/store.js';

/*
 * Search for all elements with data-qid
 * and initialize each quiz as its own Vue app + Vuex store
 */
const allQuizes = document.querySelectorAll('[data-qid]');
const isPreview = document.querySelectorAll('[data-preview]').length > 0;

allQuizes.forEach((el) => {
  const qid = el.getAttribute('data-qid');
  const app = createApp(QuizApp, { qid, preview: isPreview });
  app.use(getVuexStore()); // assumes getVuexStore() returns a Vuex 4 store instance
  app.mount(`#${el.getAttribute('id')}`);
});
